'use client';

import { isNil } from 'lodash-es';
import { createContext, useContext } from 'react';
import { useTabs } from './useTabs';

type ITabsContextType = ReturnType<typeof useTabs>;

export const TabsContext = createContext<ITabsContextType>({} as never);

export const useTabsContext = () => {
  const context = useContext(TabsContext);

  if (isNil(context)) {
    throw new Error('<Tabs /> 컴포넌트로 감싸세요.');
  }

  return context;
};
